import React from 'react'
import ReactLoading from 'react-loading';
import LoadingOverlay from 'react-loading-overlay';
import { Paper } from "@material-ui/core";
import TableView from "utils/Table/TableView";
import TablePagination from '@mui/material/TablePagination';

export default function PaginatedTable(props) {
    const rowsCount = props.rows?.length ?? 0 + props.footers?.length ?? 0;
    const rowsPerPageOptions = props.rowsPerPageOptions || [
        { value: -1, label: 'Show All' },
        { value: 32, label: '32' },
        { value: 25, label: '25' },
        { value: 10, label: '10' },
        { value: 5, label: '5' },
    ];

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(props.rowsPerPage || 32);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const isLastPage = (page == Math.ceil(rowsCount / rowsPerPage) - 1);
    const nextPage = page + 1;

    return props.loading === undefined ? (
        <Paper>
            <TableView
                style={props.style}
                fixedColumns={props.fixedColumns}
                headers={props.headers}
                rows={rowsPerPage == -1 ? props.rows : props.rows?.slice(rowsPerPage * page, rowsPerPage * nextPage)}
                footers={rowsPerPage == -1 || isLastPage ? props.footers : null}
            />
            <TablePagination
                rowsPerPageOptions={rowsPerPageOptions}
                component="div"
                count={rowsCount}
                rowsPerPage={rowsPerPage}
                page={page > 0 && rowsCount < rowsPerPage ? 0 : page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    ) : (
        <LoadingOverlay
            active={props.loading}
            styles={{ overlay: (base) => ({ ...base, position: "absolute!important" }) }}
            spinner={<ReactLoading type={'spin'} height={50} width={50} />}
        >
            <Paper>
                <TableView
                    style={props.style}
                    fixedColumns={props.fixedColumns}
                    headers={props.headers}
                    rows={rowsPerPage == -1 ? props.rows : props.rows?.slice(rowsPerPage * page, rowsPerPage * nextPage)}
                    footers={rowsPerPage == -1 || isLastPage ? props.footers : null}
                />
                <TablePagination
                    rowsPerPageOptions={rowsPerPageOptions}
                    component="div"
                    count={rowsCount}
                    rowsPerPage={rowsPerPage}
                    page={page > 0 && rowsCount < rowsPerPage ? 0 : page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </LoadingOverlay>
    );
};
